export default {"src":"/_next/static/media/image 4.c086bb0b.svg","height":295,"width":356,"blurWidth":0,"blurHeight":0};